import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import uuid from 'uuid';

// Do this typedef to make it clear that
// this is a local identifier for a resource for local use

// A store manager responsible for the lifecycle and state management of sync blocks in an editor instance.
// Supports create, read, update, and delete operations for sync blocks.
// Designed to manage local in-memory state and synchronize with an external data provider.
// Handles caching, debouncing updates, and publish/subscribe for local changes.
// Ensures consistency between local and remote state, and can be used in both editor and renderer contexts.
export var SyncBlockStoreManager = /*#__PURE__*/function () {
  function SyncBlockStoreManager(_dataProvider) {
    _classCallCheck(this, SyncBlockStoreManager);
    this.syncBlocks = new Map();
  }
  return _createClass(SyncBlockStoreManager, [{
    key: "setEditorView",
    value: function setEditorView(editorView) {
      this.editorView = editorView;
    }
  }, {
    key: "isSourceBlock",
    value: function isSourceBlock(node) {
      var _this$syncBlocks$get;
      if (node.type.name !== 'syncBlock') {
        return false;
      }
      var _node$attrs = node.attrs,
        resourceId = _node$attrs.resourceId,
        localId = _node$attrs.localId;
      return this.syncBlocks.has(resourceId) && ((_this$syncBlocks$get = this.syncBlocks.get(resourceId)) === null || _this$syncBlocks$get === void 0 ? void 0 : _this$syncBlocks$get.sourceLocalId) === localId;
    }
  }, {
    key: "registerConfirmationCallback",
    value: function registerConfirmationCallback(callback) {
      var _this = this;
      this.confirmationCallback = callback;
      return function () {
        _this.confirmationCallback = undefined;
      };
    }
  }, {
    key: "requireConfirmationBeforeDelete",
    value: function requireConfirmationBeforeDelete() {
      return !!this.confirmationCallback;
    }
  }, {
    key: "createSyncBlockNode",
    value: function createSyncBlockNode() {
      // TODO: EDITOR-1644 - properly implement creation of the synced block
      // below is a temporary implementation for the creation of the synced block
      // the resource id needs to have pageId and content property key in it

      var blockInstanceId = uuid();
      var localId = uuid();
      var syncBlockNode = {
        attrs: {
          resourceId: "ari:cloud:confluence:fake_cloud_id:page/fake_page_id/".concat(blockInstanceId),
          localId: localId
        },
        type: 'syncBlock'
      };
      this.syncBlocks.set(syncBlockNode.attrs.resourceId, {
        resourceId: syncBlockNode.attrs.resourceId,
        sourceLocalId: syncBlockNode.attrs.localId
      });
      return syncBlockNode;
    }
  }, {
    key: "deleteSyncBlocksWithConfirmation",
    value: function () {
      var _deleteSyncBlocksWithConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tr, syncBlockIds) {
        var _this2 = this;
        var confirmed, _this$editorView;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.confirmationCallback) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return this.confirmationCallback();
            case 3:
              confirmed = _context.sent;
              if (confirmed) {
                // TODO: EDITOR-1779 - "rebase" the transaction to reflect the latest document state
                (_this$editorView = this.editorView) === null || _this$editorView === void 0 || _this$editorView.dispatch(tr.setMeta('isConfirmedSyncBlockDeletion', true));
                // Need to update the BE on deletion
                syncBlockIds.forEach(function (_ref) {
                  var resourceId = _ref.resourceId;
                  return _this2.syncBlocks.delete(resourceId);
                });
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function deleteSyncBlocksWithConfirmation(_x, _x2) {
        return _deleteSyncBlocksWithConfirmation.apply(this, arguments);
      }
      return deleteSyncBlocksWithConfirmation;
    }()
  }]);
}();